import { render, staticRenderFns } from "./financialRecords.vue?vue&type=template&id=6821ec70&scoped=true&"
import script from "./financialRecords.vue?vue&type=script&lang=js&"
export * from "./financialRecords.vue?vue&type=script&lang=js&"
import style0 from "./financialRecords.vue?vue&type=style&index=0&id=6821ec70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6821ec70",
  null
  
)

export default component.exports